export default __webpack_public_path__ + "static/media/Mark-2-HUD-Targeting (Reticle).f7c50367.jpg";